export default __webpack_public_path__ + "static/media/08Africa60s.017fdf8a.mp3";